import { createAction } from '@reduxjs/toolkit';
import { ISetSplitSizesActionPayload } from '@core/types/actions';

export const setSplitSizes = createAction<ISetSplitSizesActionPayload>('block/SET_SIZES');
